<template>
  <a href="/orders/create">
    <button class="create-order-btn">
      <i class="acclaro-icon ai-add"></i>
      <span>Create New Order</span>
    </button>
  </a>
</template>

<script>
export default {
  
  props: {},
  
  computed: {},

  data () {
    return {}
  },
  
  methods: {},
}
</script>
